import {UserLevel} from '@netx/core-user/constants';

export const SHARE_MEDIA_SERVICE_SERVICES_MINIMUM_USER_LEVEL = UserLevel.ADMIN;

export enum ShareMediaServicesPref {
	ENABLED = 'mediaServices.enabled',
}
